import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '@nvidia/kaizen-ui'
import Rate from 'rc-rate'
import { Subscribe } from 'unstated'
import { BrowserView, MobileView } from 'react-device-detect'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { AppContainer } from '../../containers'
import { Article } from '../../components'
import facebook from '../../images/logo-facebook-hover.svg'
import instagram from '../../images/logo-instagram-hover.svg'
import linkedin from '../../images/logo-linkedin-hover.svg'
import twitter from '../../images/logo-twitter-bird-hover.svg'
import 'react-tabs/style/react-tabs.css'
import './inpainting-result.css'

class InpaintingResultComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      image: this.props.selectedImage,
      showMask: false,
      ratingSubmitted: false
    }
  }

  componentDidMount = () => this.props.setRequestComplete(false)

  toggleMask = () => this.setState({ showMask: !this.state.showMask})

  submitRating = (rating) => {
    const body = JSON.stringify({ rating })
    fetch(`${process.env.REACT_APP_SERVICE_ENDPOINT || 'http://52.26.183.137:8080'}/v1/partialconv/inpainting/${this.props.requestId}/rating`, {
      method: 'POST',
      headers: {
        'content-type': 'application/json'
      },
      body: body
    })
    this.setState({ ratingSubmitted: true })
  }

  clearResultsState = () => {
    this.props.setResultImage('')
    this.props.setRequestId('')
  }

  clearAppState = () => {
    this.props.setSelectedImage('')
    this.props.setLinesArray([])
    this.props.setImageMask('')
    this.props.setProcessedImageMask('')
    this.props.setResultImage('')
    this.props.setRequestId('')
  }

  render() {
    return (
      <Article className='inpainting-result'>
        <h2>Voila!</h2>
        <span className='subheader'>Inpainting complete.</span>

        <BrowserView>
          <div className='results'>
            <div className='original'>
              <div className='images'>
                <img src={this.props.selectedImage} title='original' alt='original' className='original-image' />
                {this.state.showMask && <img src={this.props.imageMask} title='mask' alt='mask' className='mask' />}
              </div>
              <p>Original Image</p>
            </div>
            <div className='result'>
              <img src={this.props.resultImage} title='' alt='' className='result-image' />
              <p>Inpainted Result</p>
            </div>
          </div>
        </BrowserView>
        <MobileView className=''>
          <Tabs defaultIndex={2}>
            <TabList>
              <Tab>Original Image</Tab>
              <Tab>Inpainting Result</Tab>
            </TabList>
            <TabPanel className='original-image'>
              <img src={this.props.selectedImage} title='original' alt='original' className='original-image' />
              {this.state.showMask && <img src={this.props.imageMask} title='mask' alt='mask' className='mask' />}
            </TabPanel>
            <TabPanel className='result-image'>
              <img src={this.props.resultImage} title='' alt='' className='result-image' />
              {this.state.showMask && <img src={this.props.imageMask} title='mask' alt='mask' className='mask' />}
            </TabPanel>
          </Tabs>
        </MobileView>

        <Button.Group className='result-controls'>
          <Button as='div' className='edit-button'>
            <Link to='masking' onClick={this.clearResultsState}>Edit Mask</Link>
          </Button>
          <Button onClick={this.toggleMask} className='toggle-mask-button'>
            {this.state.showMask ? 'Hide Mask' : 'Show Mask'}
          </Button>
          <Button
            primary
            as='div'
            className='start-over-button'
          >
            <Link to='selection' onClick={this.clearAppState}>Start Over</Link>
          </Button>
        </Button.Group>

        {!this.state.ratingSubmitted &&
          <div className='thoughts'>
            <h3>Help the algorithm learn more by providing feedback. <br /><br />What do you think?</h3>
            <Rate onChange={this.submitRating} />
          </div>
        }
        {this.state.ratingSubmitted &&
          <div className='thank-you'>
            <h3>Thank you!</h3>
            <p>We appreciate your feedback and hope you have enjoyed this demo. Please share this with your friends and colleagues.</p>
          </div>
        }

        <div className='social-media'>
          <a href='https://www.facebook.com/NVIDIA/'><img src={facebook} title='NVIDIA on Facebook' alt='NVIDIA on Facebook' /></a>
          <a href='https://www.instagram.com/nvidia/?hl=en'><img src={instagram} title='NVIDIA on Instagram' alt='NVIDIA on Instagram' /></a>
          <a href='https://www.linkedin.com/company/nvidia'><img src={linkedin} title='NVIDIA on LinkedIn' alt='NVIDIA on LinkedIn' /></a>
          <a href='http://twitter.com/nvidia'><img src={twitter} title='NVIDIA on Twitter' alt='NVIDIA on Twitter' /></a>
        </div>
      </Article>
    )
  }
}

export const InpaintingResult = () =>
  <Subscribe to={[AppContainer]}>
    {container => (
      <InpaintingResultComponent {...container.state} {...container} />
    )}
  </Subscribe>



// WEBPACK FOOTER //
// ./src/pages/InpaintingResult/InpaintingResult.js